import { SECONDARY_HEADER_HTML_ID } from '~app/modules/generic/constants';

export namespace ScrollUtils {

  const scrollTimeOut = 2000;

  /**
   * Scroll to the first instance of provided class
   * @param className The class to scroll to
   * @param behavior It can be either 'smooth' or 'auto'
   * @returns void
   */
  export function scrollToFirstOfClass(className: string, behavior: 'smooth' | 'auto' = 'smooth'): void {
    const targets: HTMLCollectionOf<Element> = document.getElementsByClassName(className);
    if (targets.length > 0) {
      const firstTarget: Element = targets[0];
      const isScrollOptionSupported = 'scrollBehavior' in document.documentElement.style;

      if (isScrollOptionSupported) {
        firstTarget.scrollIntoView({behavior, block: 'start'});
      }
    }
  }

  /**
   * Scroll to the top of the page
   * @param behavior It can be either 'smooth' or 'auto'
   * @returns void
   */
  export function scrollTop(behavior: 'smooth' | 'auto' = 'auto'): void {
    const targets = document.getElementsByTagName('body');
    if (targets.length > 0) {
      const firstTarget: Element = targets[0];
      const isScrollOptionSupported = 'scrollBehavior' in document.documentElement.style;

      if (isScrollOptionSupported) {
        firstTarget.scrollIntoView({behavior, block: 'start'});
      }
    }
  }

  /**
   * Scroll to a given ID of an element
   * @param id element id as string
   * @returns void
   */
  export function scrollToElementById(id: string): void {
    const element = document.getElementById(id);
    if (!element) {
      return;
    }
    ScrollUtils.scrollToElement(element);
  }

  /**
   * Scroll to a specific Element
   * @param element it is HTMLElement
   * @returns void
   */
  export function scrollToElement(element: HTMLElement): void {
    if (!element) {
      return;
    }

    setTimeout(() => {
      const isScrollOptionSupported = 'scrollBehavior' in document.documentElement.style;

      if (isScrollOptionSupported) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    }, scrollTimeOut);
  }

  /**
   * Scroll to Secondary header (no time out)
   * @returns void
   */
  export function scrollToSecondaryHeader(): void {
    const element = document.getElementById(SECONDARY_HEADER_HTML_ID);
    if (!element) {
      return;
    }
    const isScrollOptionSupported = 'scrollBehavior' in document.documentElement.style;
    if (isScrollOptionSupported) {
      element.scrollIntoView({behavior: 'smooth'});
    } else {
      element.scrollIntoView(true);
    }
  }

  export function scrollToInvalidElement(formElement, formGroup) {
    const invalidElements = formElement.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length) {
      formGroup.markAllAsTouched();
      const firstInvalidElement = invalidElements[0];

      const isScrollOptionSupported = 'scrollBehavior' in document.documentElement.style;

      if (isScrollOptionSupported) {
        firstInvalidElement.scrollIntoView({behavior: 'smooth'});
      }
    }
  }
}
